import { SipNumberResponse } from "../../model/sipNumberResponse";
import { SelectOptionsType } from "../../utils/select-helpers";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipNumberResponse;

type FetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type TransformedDataType = DtoType;

export type GuiResponseType = {
  data?: SelectOptionsType[];
  error?: string;
};

export async function getSipNumbersUnPooled(): Promise<GuiResponseType> {
  try {
    const url = apiUrls.getSipNumbersUnPooled;
    const response: FetchResponseType = await fetchGetJSON(url);
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const xResponseData = response.data.map((sipNumber) => {
        return {
          title: "",
          value: `${sipNumber.id}`,
          label: `${sipNumber.phoneNumber}`,
        };
      });

      return { data: xResponseData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error getSipNumbersUnPooled:%o", err);
    return { error: (err as Error).message };
  }
}
